import { render, staticRenderFns } from "./TaskMsgCard.vue?vue&type=template&id=4de8851c&scoped=true&"
import script from "./TaskMsgCard.vue?vue&type=script&lang=js&"
export * from "./TaskMsgCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskMsgCard.vue?vue&type=style&index=0&id=4de8851c&prod&lang=css&"
import style1 from "./TaskMsgCard.vue?vue&type=style&index=1&id=4de8851c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8851c",
  null
  
)

export default component.exports